import React, { type FC } from 'react'

import { GRID_VARIANT_SMALL, Grid, GridCell } from 'mailup-web-components'

import InputCritType from 'Pages/RecipientsList/components/filters/InputCritType'

import InputGroupMatchOperator from 'Pages/RecipientsList/components/filters/groups/InputGroupMatchOperator'

import InputGroups from 'Pages/RecipientsList/components/filters/groups/InputGroups'

import ActionDeleteCriterion from 'Pages/RecipientsList/components/filters/ActionDeleteCriterion'

interface CriterionGroupsProps {
  index: number
}

const CriterionGroups: FC<CriterionGroupsProps> = ({ index }) => {
  return (
    <Grid variant={GRID_VARIANT_SMALL} cols={12}>
      <GridCell span={3}>
        <InputCritType index={index} />
      </GridCell>
      <GridCell span={2}>
        <InputGroupMatchOperator index={index} />
      </GridCell>
      <GridCell span={6}>
        <InputGroups index={index} />
      </GridCell>
      <GridCell span={1}>
        <ActionDeleteCriterion index={index} />
      </GridCell>
    </Grid>
  )
}

export default CriterionGroups
